module.exports = __webpack_public_path__ + "img/img-prebuilt-automation.44559fb8.svg";